const input = "_35sijlf6cw";

export { input };
import "./input.style.linaria.module.css";
//# sourceMappingURL=input.style.js.map
